// Anonymous visitor id used by the recommendation engine to personalise
// the "Recommended for You" strip for non-logged-in shoppers.
const KEY = "cultlyf_visitor_id";

function makeId() {
  const rnd = Math.random().toString(36).slice(2, 10);
  const t = Date.now().toString(36);
  return `v_${t}_${rnd}`;
}

export function getVisitorId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = makeId();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return "";
  }
}
